// Retrieve initial state from localStorage if available
const getInitialCart = () => {
  const storedCart = localStorage.getItem("cart");
  return storedCart ? JSON.parse(storedCart) : [];
};

const handleCart = (state = getInitialCart(), action) => {
  const product = action.payload;
  let updatedCart;

  switch (action.type) {

    case "SET_CART":
      updatedCart = action.payload;
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;


    case "ADDITEM":
      const exist = state.find((x) => x.id === product.id);
      if (exist) {
        updatedCart = state.map((x) =>
          x.id === product.id ? { ...x, qty: x.qty + 1 } : x
        );
      } else {
        updatedCart = [...state, { ...product, qty: 1 }];
      }
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;

    case "DELITEM":
      const exist2 = state.find((x) => x.id === product.id);
      if (exist2.qty === 1) {
        updatedCart = state.filter((x) => x.id !== exist2.id);
      } else {
        updatedCart = state.map((x) =>
          x.id === product.id ? { ...x, qty: x.qty - 1 } : x
        );
      }
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;

    case "CLEAR_CART":
      localStorage.removeItem("cart");
      return [];

    default:
      return state;
  }
};

export default handleCart;

// Action creators
export const addCart = (product) => ({
  type: "ADDITEM",
  payload: product,
});

export const delCart = (product) => ({
  type: "DELITEM",
  payload: product,
});

export const clearCart = () => ({
  type: "CLEAR_CART",
});
